// extracted by mini-css-extract-plugin
module.exports = {"overlay":"tooltip_overlay__1q-1E"};